import { Component, OnInit,Inject, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
import { FormBuilder, Validators } from '@angular/forms'
import { NotificationService } from '../notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';
@Component({
  selector: 'app-dltpopup',
  templateUrl: './dltpopup.component.html',
  styleUrls: ['./dltpopup.component.scss']
})
export class DltpopupComponent implements OnInit {
  isDeleted = new EventEmitter()
  constructor(@Inject(MAT_DIALOG_DATA) private data:any,private fb: FormBuilder,private notification:NotificationService,public service:CommonService,private snack:MatSnackBar ,public dialog: MatDialog,private router: Router,private dialogRef: MatDialogRef<DltpopupComponent>) { }

  ngOnInit(): void {
  }
  customerDelete(){
    this.service.deletePost(this.data)
    .subscribe((res:any)=>{
      if(res.message == "Success"){
        this.notification.showInfo("Deleted successfully",'')
        // this.snack.open("Deleted successfully",'',{
        //   duration:3000,
        //  verticalPosition:'top',
        //  horizontalPosition: 'end',

        // })
        this.isDeleted.emit(true)
        this.dialogRef.close();
        
      }else{
        alert("something went wrong");
      }
     
    })
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
